export class Employee {
  public constructor(
    public id: number = 0,
    public name?: string,
    public family?: string,
    public companyName?: string,
    public position?: string,
    public mail?: string,
    public phone?: string,
    public accessLevel?: EmployeeAccessLevel,
    public kpiAccessLevel?: EmployeeAccessLevel,
    public financialStatementAccessLevel?: EmployeeAccessLevel,
    public accessStatus?: string,
    public uuid?: string,
    public photo?: string,
    public idCompany?: number,
    public portalAdminAccess?: boolean,
    public dataRoomAccess?: boolean,
    public portfolioNotification?: boolean,
    public kpiNotification?: boolean,
    public lastNotification?: Date,
    public portalPdf?: boolean,
    public marketAnalysis?: boolean,
    public kpis?: boolean,
    public organizationAdmin?: boolean,
    public orgId?: number,
  ) {}

  static deserialize(object: Employee): Employee {
    return Object.assign(new Employee(), object);
  }

  hasNoAccess(): boolean {
    return this.financialStatementAccessLevel === 'No Access' &&
           this.kpiAccessLevel === 'No Access' &&
           !this.portalAdminAccess &&
           !this.portfolioNotification &&
           !this.portalPdf &&
           !this.marketAnalysis &&
           !this.dataRoomAccess &&
           this.accessLevel === 'No Access' &&
           !this.kpiNotification;
  }

  hasAtLeastOneAccess(): boolean {
    return this.financialStatementAccessLevel !== 'No Access' ||
           this.kpiAccessLevel !== 'No Access' ||
           this.portalAdminAccess ||
           this.portfolioNotification ||
           this.portalPdf ||
           this.marketAnalysis ||
           this.dataRoomAccess ||
           this.accessLevel !== 'No Access' ||
           this.kpiNotification;
  }
}

export type EmployeeAccessLevel = 'No Access' | 'Viewer' | 'Admin';
